import React, { useState, useEffect } from 'react';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { saveAs } from 'file-saver';
import '../styles.css';
import moment from 'moment';
import { Button } from 'react-bootstrap';

import BuySellService from '../../../services/buy-sell.service';
import { toast } from 'react-toastify';
import Loader from '../../../shared/common/loader';
import {
  addThousandSeparators,
  formatAmount,
  getTransactionType,
} from '../../../utils';
import '../styles.css';
import { useHistory } from 'react-router-dom';
import {
  BUYBACK_INVOICE_APPROVAL_MESSAGE,
  BUYBACK_INVOICE_UPLOAD_MESSAGE,
  INCOMPLETE_BUYBACK_INVOICE,
  INCOMPLETE_SELL_INVOICE,
  PAYMENT_PENDING_MESSAGE,
} from 'constants/messages.constant';
import { userStore } from 'store/UserStore';

interface PropsType {
  handleModal: any;
  isShow: boolean;
  data: any;
  isPassbookRedirect?: boolean;
  displaySummary: boolean;
  displayInvoice: boolean;
}

const OrderSummary: React.FC<PropsType> = ({
  handleModal,
  isShow,
  data,
  isPassbookRedirect,
  displaySummary,
  displayInvoice,
}) => {
  const [loading, setLoading] = useState<any>(false);
  const [message, setMessage] = useState('');
  const [customer, user] = userStore((state: any) => [
    state.customer,
    state.user,
  ]);
  useEffect(() => {
    switch (data?.status) {
      case 'PAYMENT_PENDING':
        setMessage(PAYMENT_PENDING_MESSAGE);
        break;
      case 'PENDING':
        setMessage(
          data.type === 'SELL'
            ? INCOMPLETE_SELL_INVOICE
            : INCOMPLETE_BUYBACK_INVOICE
        );
        break;
      case 'CREATED':
        setMessage(PAYMENT_PENDING_MESSAGE);
        break;
      case 'INVOICE_UPLOAD_PENDING':
        setMessage(BUYBACK_INVOICE_UPLOAD_MESSAGE);
        break;
      case 'INVOICE_APPROVAL_PENDING':
        setMessage(BUYBACK_INVOICE_APPROVAL_MESSAGE);
        break;
      default:
        setMessage('');
        break;
    }
  }, [data?.status]);

  let history = useHistory();

  /**
   * Download invoice pdf
   */
  const onDownloadInvoice = async () => {
    if (data.invoiceIds.length > 0) {
      try {
        setLoading(true);
        const res: any = await BuySellService.downloadInvoice(
          data.invoiceIds[0],
          user?.userId
        );
        if (res.status === 200 && res.data) {
          setLoading(false);
          saveAs(res.data.data.fileUrl, `INVOICE_${data.invoiceIds[0]}`);
          window.location.assign(res.data.data.fileUrl);
          // window.open(res.data.data.fileUrl);
        }
      } catch (error: any) {
        setLoading(false);
        if (error.data.errors && error.data.errors.length > 0)
          return toast.error(error.data.errors[0].title);
        return toast.error('Something went wrong');
      }
    } else {
      return toast.error('No invoices to download');
    }
  };

  /**
   * Download order summary pdf
   */
  const onDownloadOrderSummary = async () => {
    try {
      setLoading(true);
      const res: any = await BuySellService.downloadOrderSummary(
        data.ebOrderRef,
        user?.userId
      );
      if (res.status === 200 && res.data) {
        setLoading(false);
        // window.open(res.data.data.fileUrl);
        saveAs(res.data.data.fileUrl, `ORDER_SUMMARY_${data.ebOrderRef}`);
        window.location.assign(res.data.data.fileUrl);
      }
    } catch (error: any) {
      setLoading(false);
      if (error.data.errors.length > 0) {
        return toast.error(error.data.errors[0].title);
      }
    }
  };

  const calcTotalTax = (taxes: any) => {
    let initialValue = 0;
    let sum = taxes.reduce(function (accumulator, curValue) {
      return accumulator + curValue.value;
    }, initialValue);
    return sum;
  };

  return (
    <>
      {loading && <Loader />}
      {data && (
        <>
          <Offcanvas
            show={isShow}
            onHide={() => handleModal(false)}
            placement='end'
          >
            <Offcanvas.Header closeButton className='bg-light'>
              <Offcanvas.Title>
                <h5 className='px-4 font-weight-bold'>Order Summary</h5>
              </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <div className='px-4'>
                <h5>
                  Your{' '}
                  {data.items.length > 0 &&
                    data.items[0].itemBreakDown.length > 0 &&
                    data.items[0].itemBreakDown[0].name}{' '}
                  {data.type === 'SELL' ? 'Purchase' : 'Sales'}
                </h5>
                <div className='row py-3 justify-content-between border-bottom'>
                  {/* <div className='col-md-6 mb-2'>Order Status</div>
                  <div className='col-md-6  mb-2 text-end'>
                    <div className='badge bg-secondary'>
                      <b>{data.status}</b>
                    </div>
                  </div> */}
                  <div className='col-md-6 col-6 mb-3'>Order Status</div>
                  <div className='col-md-6 col-6 mb-3 text-md-end text-end'>
                    <div className='badge bg-secondary'>
                      <b>{data.status}</b>
                    </div>
                  </div>
                  <div className='col-md-6 col-6 mb-3'>Order Number</div>
                  {/* <div className='col-md-6 mb-2 text-end'> */}
                  <div className='col-md-6 col-6 mb-3 text-md-end text-end'>
                    <b>{data.ebOrderRef}</b>
                  </div>
                  <div className='col-md-6 col-6 mb-3'>Date</div>
                  {/* <div className='col-md-6 mb-2 text-end'> */}
                  <div className='col-md-6 col-6 mb-3 text-md-end text-end'>
                    <b>
                      {moment(data.createdAtUnix).format(
                        'DD-MMM-yyyy  hh:mm:ss A'
                      )}
                    </b>
                  </div>
                  <div className='col-md-6 col-6 mb-3'>Payment Mode</div>
                  {/* <div className='col-md-6 mb-2 text-end'> */}
                  <div className='col-md-6 col-6 mb-3 text-md-end text-end'>
                    <b>{getTransactionType(data)}</b>
                  </div>
                </div>

                <div className='row py-3 justify-content-between border-bottom'>
                  <div className='col-md-6 col-6 mb-3'>Rate</div>
                  {/* <div className='col-md-6 mb-2 text-end'> */}
                  <div className='col-md-6 col-6 mb-3 text-md-end text-end'>
                    <b>
                      ₹{' '}
                      {data.items.length > 0 &&
                        data.items[0].itemBreakDown.length > 0 &&
                        formatAmount(
                          data.items[0].itemBreakDown[0].summary.unitPrice,
                          2
                        )}
                      /g
                    </b>
                  </div>
                  <div className='col-md-6 col-6  mb-3'>Quantity</div>
                  {/* <div className='col-md-6 mb-2 text-end'> */}
                  <div className='col-md-6 col-6 mb-3 text-md-end text-end'>
                    <b>
                      {data.items.length > 0 &&
                        data.items[0].itemBreakDown.length > 0 &&
                        data.items[0].itemBreakDown[0].summary.originalQuantity.toFixed(
                          4
                        )}{' '}
                      g
                    </b>
                  </div>
                  {data.items[0].itemBreakDown[0].summary.adjustedQuantity !==
                    0 && (
                    <>
                      <div className='col-md-6 col-6 mb-3'>
                        Product Discount
                      </div>
                      {/* <div className='col-md-6 mb-2 text-end'> */}
                      <div className='col-md-6 col-6 mb-3 text-md-end text-end'>
                        <b>
                          {data.items.length > 0 &&
                            data.items[0].itemBreakDown.length > 0 &&
                            data.items[0].itemBreakDown[0].summary.adjustedQuantity.toFixed(
                              4
                            )}{' '}
                          g
                        </b>
                      </div>
                    </>
                  )}
                </div>

                {data.summary.itemTotalDiscount !== 0 && (
                  <>
                    <div className='row py-3 justify-content-between border-bottom'>
                      <div className='col-md-6 col-6 mb-3'>Discount</div>
                      {/* <div className='col-md-6 mb-2 text-end'> */}
                      <div className='col-md-6 col-6 mb-3 text-md-end text-end'>
                        <b>
                          {' '}
                          - ₹{' '}
                          {data.items.length > 0 &&
                            formatAmount(
                              data.items[0].summary.itemTotalDiscount
                            )}
                        </b>
                      </div>
                    </div>
                  </>
                )}

                <div className='row py-3 justify-content-between border-bottom'>
                  <div className='col-md-6 col-6 mb-2'>Line Amount</div>
                  <div className='col-md-6 col-6 mb-3 text-md-end text-end'>
                    {/* <div className='col-md-6 mb-2 text-end'> */}
                    <b>
                      ₹{' '}
                      {data.items.length > 0 &&
                        data.items[0].itemBreakDown.length > 0 &&
                        formatAmount(
                          data.items[0].itemBreakDown[0].summary.lineAmount
                        )}
                    </b>
                  </div>
                </div>
                {data.items.length > 0 &&
                  data.items[0].itemBreakDown.length > 0 &&
                  data.items[0].itemBreakDown[0].taxes.length > 0 && (
                    <div className='row py-3 justify-content-between border-bottom'>
                      <div className='col-md-6 col-6 mb-3'>
                        <h6>Tax & Charges</h6>
                      </div>
                      {/* <div className='col-md-6 text-end'> */}
                      <div className='col-md-6 col-6 mb-3 text-md-end text-end'>
                        <b>
                          ₹{' '}
                          {data.items.length > 0 &&
                          data.items[0].itemBreakDown.length > 0 &&
                          data.items[0].itemBreakDown[0].taxes.length > 0
                            ? formatAmount(
                                calcTotalTax(
                                  data.items[0].itemBreakDown[0].taxes
                                )
                              )
                            : //  formatAmount(data.items[0].itemBreakDown[0].taxes.reduce((accumulator, curr) => accumulator + curr.value))
                              '0.00'}
                        </b>
                      </div>
                      {data.items.length > 0 &&
                        data.items[0].itemBreakDown.length > 0 &&
                        data.items[0].itemBreakDown[0].taxes.map(
                          (tax: any, index: number) => {
                            return (
                              <div
                                className='row justify-content-between p-0'
                                key={index}
                              >
                                <div className='col-md-6 col-6 mb-3 text-secondary tax-type'>
                                  {tax.subTaxType}
                                </div>
                                {/* <div className='col-md-6 text-end p-0'> */}
                                <div className='col-md-6 col-6 mb-3 text-md-end text-end p-0'>
                                  ₹ {formatAmount(tax.value)}
                                </div>
                              </div>
                            );
                          }
                        )}
                    </div>
                  )}
                {data.summary.quotationTax !== 0 && (
                  <div className='row py-3 justify-content-between border-bottom'>
                    <div className='col-md-6 col-6 mb-3'>
                      <h6>Other Charges and Taxes</h6>
                    </div>
                    {/* <div className='col-md-6 text-end'> */}
                    <div className='col-md-6 col-6 mb-3 text-md-end text-end'>
                      <b>₹ {formatAmount(data.summary.quotationTax)}</b>
                    </div>
                    {data.invoiceTaxes.length > 0 &&
                      data.invoiceTaxes.map((tax: any, index: number) => {
                        return (
                          <div
                            className='row justify-content-between p-0'
                            key={index}
                          >
                            <div className='col-md-6 text-secondary tax-type'>
                              {tax.taxSubType +
                                ' (' +
                                addThousandSeparators(tax.value) +
                                '%)'}
                            </div>
                            <div className='col-md-6 text-end p-0'>
                              ₹ {formatAmount(tax.amount)}
                            </div>
                          </div>
                        );
                      })}
                  </div>
                )}

                {data.items[0].itemBreakDown[0].summary?.roundingDifference !==
                  0 &&
                (data.items[0].itemBreakDown[0].summary?.roundingDifference >
                  0 ||
                  data.items[0].itemBreakDown[0].summary?.roundingDifference <
                    0) ? (
                  <div className='row py-3 justify-content-between border-bottom'>
                    <div className='col-md-6 col-6 mb-3'>
                      Rounding Difference
                    </div>
                    {/* <div className='col-md-6 mb-2 text-end'> */}
                    <div className='col-md-6 col-6 mb-3 text-md-end text-end'>
                      <b>
                        ₹{' '}
                        {data.items.length > 0 &&
                          data.items[0].itemBreakDown.length > 0 &&
                          formatAmount(
                            data.items[0].itemBreakDown[0].summary
                              ?.roundingDifference
                          )}
                      </b>
                    </div>
                  </div>
                ) : (
                  <></>
                )}

                <div className='row py-3 justify-content-between border-bottom'>
                  <div className='col-md-6 mb-3 col-6'>
                    <b>Total</b>
                  </div>
                  {/* <div className='col-md-6 mb-2 text-end'> */}
                  <div className='col-md-6 col-6 mb-3 text-md-end text-end'>
                    <b>₹ {formatAmount(data.summary.quotationTotal)}</b>
                  </div>
                </div>
                {data.status !== 'COMPLETED' ? (
                  isPassbookRedirect ? (
                    <div className='d-grid mt-4'>
                      <Button
                        variant='primary'
                        className='btn-block'
                        onClick={() => history.push('/passbook')}
                        size='lg'
                      >
                        View Passbook
                      </Button>
                    </div>
                  ) : message ? (
                    <>
                      <p className='my-3 h5'>{message}</p>
                    </>
                  ) : null
                ) : (
                  <>
                    {data.status !== 'CREATED' &&
                      data.status !== 'PAYMENT_PENDING' &&
                      data?.order.paymentMethod !== 'GIFT' &&
                      displaySummary && (
                        <div className='d-grid mt-4'>
                          <Button
                            variant='primary'
                            className='btn-block'
                            onClick={onDownloadOrderSummary}
                            size='lg'
                          >
                            Download Order Summary
                          </Button>
                        </div>
                      )}
                    {data.status === 'COMPLETED' && displayInvoice &&   data?.order.paymentMethod !== 'GIFT' && (
                      <div className='d-grid mt-4'>
                        <Button
                          variant='primary'
                          className='btn-block'
                          onClick={onDownloadInvoice}
                          size='lg'
                        >
                          Download Invoice
                        </Button>
                      </div>
                    )}
                  </>
                )}
              </div>
            </Offcanvas.Body>
          </Offcanvas>
        </>
      )}
    </>
  );
};

export default OrderSummary;
